export const IS_DEV = import.meta.env.DEV

export const QueryStateKeys = {
  TableSortBy: 'tableSortBy',
  TableSortType: 'tableSortType',
  TablePage: 'tablePage',
  TablePageSize: 'tablePageSize',
  GenerateLinkId: 'generateLinkId',
  HideIncompleteVerifications: 'hideIncompleteVerifications',
  HideIncompleteCases: 'HideIncompleteCases',
  SearchKey: 'searchKey',
  SearchValue: 'searchValue',
  ShowActiveUsers: 'ShowActiveUsers',
  onlyInactiveWorkflows: 'onlyInactiveWorkflows',
} as const

export const SessionStorageKeys = {
  resendEmailTimer: 'resendEmailTimer',
} as const

export const localStorageKeys = {
  accessToken: 'dtAccessToken',
  xUserClientToken: 'dtXUserClientToken',
  verificationId: (key: string) => `dtVerificationId-${key}`,
  userClientChatThread: (key: string) => `dtUserClientChatThread-${key}`,
  // Floating vs docked panel layout, per chat kind (not per form/verification) — the layout is a
  // user preference that should carry across whatever they open next.
  chatDisplayMode: (chat: string) => `dtChatMode-${chat}`,
  // Dragged panel width, per chat kind and layout — a floating window and a docked column want
  // different widths, so they remember them separately.
  chatWidth: (chat: string, layout: string) => `dtChatWidth-${chat}-${layout}`,
  userClientFormChatThread: (key: string) => `dtUserClientFormChatThread-${key}`,
  formBuilderChatThread: (key: string) => `dtFormBuilderChatThread-${key}`,
  forms: 'dtForms',
  verification: 'dtVerification',
  lastActivity: 'dtLastActivity',
  logoutLock: 'dtLogoutLock',
  tablePageSize: 'dtTablePageSize',
} as const

export const TableParamsKey = {
  Links: 'links',
  Profiles: 'profiles',
  Verifications: 'verifications',
  Cases: 'cases',
  Workflows: 'workflows',
  ProfileVerifications: 'profile-verifications',
  ProfileCases: 'profile-cases',
  CaseProfiles: 'case-profiles',
  CaseVerifications: 'case-verifications',
  CaseDocuments: 'case-documents',
  CaseNotes: 'case-notes',
  CaseAudit: 'case-audit',
  TeamAudit: 'team-audit',
  TeamUsers: 'team-users',
  VerificationProfiles: 'verification-profiles',
  VerificationAudit: 'verification-audit',
  ApiKeyGenerate: 'api-key-generate',
  ApiKeyView: 'api-key-view',
  DashboardCases: 'dashboard-cases',
  UserSettingsProduct: 'user-settings-product',
  UserSettingsEntity: 'user-settings-entity',
  ScreeningsNaturalPersons: 'screenings-natural-persons',
  ScreeningsLegalEntity: 'screenings-legal-entity',
  Webhooks: 'webhooks',
} as const

export type TableParamsKeyValue = (typeof TableParamsKey)[keyof typeof TableParamsKey]
